import React,{ useState, useEffect }  from 'react'
import {Card} from 'react-bootstrap'

import Sides from '../Bars/Diffjvsp';
import Button from 'react-bootstrap/Button'

import { Helmet } from "react-helmet";
function Jpif(){


    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(3)
      } else {
        setWindowpadding(15)
      }
    }
  
    
  

return(
    <div>
   <Sides />
        <Helmet>
 
 <title>Difference Between Java and Python if tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and Python if tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,if,tutorial for begineers,Difference Between Java and Python,Difference between program and code,java tutorial for begineers,python tutorial for begineers,C# tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and python tutorial,code,exampler,java vs python if,java vs Csharp(C#),if"/>
<link rel="canonical" href="https://www.codeexampler.com/java-vs-python-if" />
</Helmet>
<div className='lg:pl-56'>
    <h1 className="m-4 mh1">Difference Between Java and Python if</h1>
    <div className="first">
        <a href="/java-vs-python-basic">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 ">Syntax of Java if statement:
     </h2>
     <Card className='inde' border="primary m-4">
                <Card.Header as="h5">Java if statement syntax
                    </Card.Header>
                <Card.Body>
                    <Card.Text>
                    
                    <span className="re"> if(condition)</span><br />
                        &#123;<br />
                        <span className="yl">  body</span><br />
                        &#125;<br />
                    </Card.Text>
                </Card.Body>
            </Card>

<h2 className="mt-4 mh2">
Python if statement</h2>
          
<Card className='inde' border="primary m-4">
  <Card.Header as="h5">Python if Statement Syntax</Card.Header>
  <Card.Body>
    <Card.Text>
    <p><span className="bl">If (condition)</span><br/>
         Statement;<br/>
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
Difference Between Java and Python Example</h2>

<h3 className="mt-4">Java If Example</h3>


<Card className='inde' border="primary m-4">
      <Card.Header as="h5">Q- Write a program to input a number and check this number is more than or equal to 100 in Java if statement?
            </Card.Header>
                <Card.Body>
                    <Card.Text>
                    <span className="re"> public</span> class  <span className="gr">if_example</span> <span className="bold">&#47;&#47;<span className="yl"> class</span> is a <span className="bl">keyword</span></span><br />
                    &#123;<br />
                    <span className="re">public</span> static void main(String[] args)<br />
                    &#123;<br />
                    <span className="gr">int</span> <span className="yl">a</span>=500;<br />
                    <span className="bl">if</span>(<span className="yl">a</span>&#62;100)<br />
                    System.out.<span className="re">println</span>("a is greater");<br />
                    &#125;<br />
                    &#125;   <br />
                    </Card.Text>

                </Card.Body>
                <Card.Footer>Output -<br />a is greater</Card.Footer>
            </Card>

<h3 className="mt-4">Python if Example</h3>

<Card className='inde' border="primary m-4">
   <Card.Header as="h5">Q-Write a program to input a number and check this number is more than or equal to 100 in Python if statement?
    </Card.Header>
       <Card.Body>
     <Card.Text>
      <p>
      <span className="re">a</span>=500;<br/>
      <span className="yl">if</span>(<span className="re">a</span>&#62;100):<br/>
  print("a is greater")
     </p>
   </Card.Text>
    </Card.Body>
   <Card.Footer>Output-<br/>a is greater</Card.Footer>
   </Card>
   <h1 className="mt-5">  </h1>
   <div className="back">
        <a href="/java-vs-python-basic">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jpif;